import {useMemo} from "react";
import {fetchProduct} from "../infrastructure/productApi";
import {useRemoteData} from "../../common/utils/useRemoteData";

export const useProduct = (productCode) => {
    const fetchProductFn = useMemo(
        () => (() => fetchProduct(productCode)),
        [productCode]
    );

    const productRemoteData = useRemoteData(
        {
            initial: null,
            dataFetchingCallback: fetchProductFn
        });

    return {productRemoteData};
};
